var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"blue-title"},[_vm._v("请读取身份证信息")]),_vm._v(" "),_c('img',{attrs:{"src":require("../../../../../../assets/common/fake-card.png"),"alt":""}}),_vm._v(" "),(_vm.socket)?_c('el-button',{attrs:{"loading":_vm.loading}},[_vm._v(_vm._s(_vm.readText))]):_c('el-button',[_vm._v("将身份证放置到读卡器上后等待自动读取")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }